import { Input, Text, HStack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import * as Clipboard from 'expo-clipboard';
import { Box, Input as NBInput } from 'native-base';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  NativeSyntheticEvent,
  TextInputChangeEventData,
  TextInputKeyPressEventData,
} from 'react-native';
interface SplitInputProps {
  setValue: React.Dispatch<React.SetStateAction<string>>;
  value: string;
  isError: boolean;
}

const tokenDigits = 6;

export const SplitInput: React.FC<SplitInputProps> = ({ setValue, isError }) => {
  const tokenRefs = useRef(
    Array.from({ length: tokenDigits }, () => React.createRef<typeof NBInput>())
  ).current;
  const blankText = useRef<boolean[]>(tokenRefs.map(() => true));
  const [textValues, setTextValues] = useState<string[]>(tokenRefs.map(() => ''));

  const handleKeyPress = useCallback(
    (e: NativeSyntheticEvent<TextInputKeyPressEventData>, index: number) => {
      if (e.nativeEvent.key === 'Backspace') {
        if (tokenRefs[index - 1] && blankText.current[index]) {
          // @ts-expect-error
          tokenRefs[index - 1].current?.focus();
        }

        setTextValues((currentTextValues) =>
          currentTextValues.map((val, i) => (i === index ? '' : val))
        );

        blankText.current[index] = true;
      }
    },
    [tokenRefs]
  );

  const handleChange = useCallback(
    async (e: NativeSyntheticEvent<TextInputChangeEventData>, index: number) => {
      if (e.nativeEvent.text.length === 1) {
        blankText.current[index] = false;
        setTextValues((currentTextValues) =>
          currentTextValues.map((val, i) => (i === index ? e.nativeEvent.text : val))
        );

        if (tokenRefs[index + 1]) {
          // @ts-expect-error
          tokenRefs[index + 1].current?.focus();
        }
      } else if (e.nativeEvent.text.length === tokenDigits) {
        const clipboardContent = await Clipboard.getStringAsync();

        if (clipboardContent.length === tokenDigits && clipboardContent.match(/\d{6}/)) {
          setTextValues(clipboardContent.split(''));
        }
      }
    },
    [tokenRefs]
  );

  useEffect(() => {
    if (setValue && textValues.every((currentValue) => currentValue?.length === 1)) {
      setValue(textValues.join(''));
    } else {
      setValue?.('');
    }
  }, [setValue, textValues]);

  const tokenInputs = useMemo(
    () =>
      tokenRefs.map((tokenRef, index) => (
        <Box h="58px" key={index.toString()} flex={1}>
          <Input
            formControlFlex={1}
            autoComplete="off"
            keyboardType="number-pad"
            variant="token"
            name={`tokenDigit_${index}`}
            onKeyPress={(e) => handleKeyPress(e, index)}
            onChange={(e) => handleChange(e, index)}
            ref={tokenRef}
            hasShadow={false}
            value={textValues[index]}
            textAlign="center"
            flex={1}
          />
        </Box>
      )),
    [handleChange, handleKeyPress, textValues, tokenRefs]
  );

  return (
    <VStack flexDirection={'column'} flex={1}>
      <HStack justifyContent="space-between" space={Spacing['inline.nano']}>
        {tokenInputs}
      </HStack>
      <Box height={Spacing['inline.xxxs']} marginTop={'-16px'}>
        {isError && (
          <Text position={'absolute'} bottom={'-16px'} color="feedback.error.default">
            Token de verificação inválido
          </Text>
        )}
      </Box>
    </VStack>
  );
};
